export default "__VITE_ASSET__9$WT_xEc__"